import styled from '@emotion/styled';
import vars from '../../variables';
import { defineResponsiveGridColumns } from '../../utils/utils';
import { sectionTitleBorder } from '../../mixins';
import { H2Atom, PAtom } from '@atoms/text-atoms/text-atoms';

export const FlipCardBlockContainer = styled.div<{ colour?: string }>`
  width: 100%;
  margin: ${vars.spacingL} auto;
  color: ${({ colour }) => colour};
`;

export const ComponentGridStructure = styled.div`
  display: grid;
  column-gap: ${vars.mobileColumnPercentageGap};
  grid-template-columns: ${defineResponsiveGridColumns(4)};
  @media screen and (min-width: ${vars.breakPointTablet}) {
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(12)};
  }
`;

export const Title = styled(H2Atom)`
  ${({ color }) => sectionTitleBorder(color || vars.coreDarkGrey)}
  &::first-letter {
    text-transform: uppercase;
  }
  margin-bottom: ${vars.spacingM};
  grid-column: col1-start / col3-end;
  @media screen and (min-width: ${vars.breakPointTablet}) {
    grid-column: col1-start / col5-end;
    margin-bottom: ${vars.spacingM};
  }
`;

export const Description = styled(PAtom)`
  padding: 0;
  @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
    max-width: 70%;
  }
`;

export const CardsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${defineResponsiveGridColumns(1)};
  grid-column: col1-start / col4-end;
  gap: 20px;

  @media screen and (min-width: ${vars.breakPointTablet}) {
    grid-column: col1-start / col12-end;
    grid-template-columns: ${defineResponsiveGridColumns(3)};
  }
`;
